import {
  FETCH_USER_ISSUED_BADGES_FOR_COURSE_START,
  FETCH_USER_ISSUED_BADGES_FOR_COURSE_SUCCESS,
  FETCH_USER_ISSUED_BADGES_FOR_COURSE_FAILURE,
} from './actions';
import { ResourceApi } from '../../resource/Resource';
import { makeSelectUserCohortBadgesHasLoaded } from './selectors';
import {
  currentCohortPathSelector,
  currentUserIdSelector,
} from '../Auth/selectors';

const fetchUserIssuedBadges = () => {
  return (dispatch, getState) => {
    const state = getState();
    const userId = currentUserIdSelector(state);
    const cohortPath = currentCohortPathSelector(state);
    const hasLoaded = makeSelectUserCohortBadgesHasLoaded(
      userId,
      cohortPath
    )(state);

    if (userId && cohortPath && !hasLoaded) {
      dispatch({
        type: FETCH_USER_ISSUED_BADGES_FOR_COURSE_START,
        userId,
        cohortPath,
      });

      return ResourceApi.lookup('badge', 'getIssuedBadgesForUserCohort', {
        cohortPath,
      }).then(
        (issuedBadges) =>
          dispatch({
            type: FETCH_USER_ISSUED_BADGES_FOR_COURSE_SUCCESS,
            userId,
            cohortPath,
            issuedBadges,
          }),
        (err) => {
          dispatch({
            type: FETCH_USER_ISSUED_BADGES_FOR_COURSE_FAILURE,
            error: err.message,
          });
        }
      );
    } else {
      return Promise.resolve();
    }
  };
};

export const loadCurrentUserIssuedBadges = (dispatch) => {
  return dispatch(fetchUserIssuedBadges());
};
